import {BasketLineItem} from 'types';

export const checkIfWeightedFresh = (basketItems: BasketLineItem[]) => {
  if (!basketItems) {
    return false;
  }

  const weightedFreshProduct = basketItems.find((item: BasketLineItem) => item?.productDetails?.isWeightedFresh);

  return Boolean(weightedFreshProduct && Object.keys(weightedFreshProduct).length > 0);
};

export const checkIfWeightedFreshSelected = (basketItems: BasketLineItem[], selectedItems: string[]) => {
  if (!basketItems || !selectedItems) {
    return false;
  }

  return basketItems?.some(
    (item: BasketLineItem) => item?.productDetails?.isWeightedFresh && selectedItems?.includes(item.productId)
  );
};

export const isAllItemsFromThisSectionAreSelected = (
  sectionItems: BasketLineItem[],
  selectedItems: string[] | undefined
) => {
  const sectionItemsIds = getIdsFromBasketItems(sectionItems);
  const selectedItemOfThisSection = selectedItems?.filter((id) => sectionItemsIds.includes(id));
  return sectionItemsIds?.length === selectedItemOfThisSection?.length;
};

export const checkIfAnyItemFromSectionIsSelected = (sectionItems: BasketLineItem[], selectedItems: string[]) => {
  return sectionItems.some((item) => selectedItems?.includes(item.productId));
};

export const getIdsFromBasketItems = (basketItems: BasketLineItem[]) => basketItems.map((itm) => itm.productId);
